export default __webpack_public_path__ + "static/media/6.2.ea3e24bf.jpg";